<script>
export default {
  components: {},
  props: {
    isSidebarCollapsed: {
      type: Boolean,
      required: false,
    },
    fullName: {
      type: String,
      required: true,
      default: '',
    },
    avatar: {
      type: String,
      required: true,
      default: '',
    },
    gender: {
      type: String,
      required: false,
      default: '',
    },
    dob: {
      type: String,
      required: false,
      default: '',
    },
    userHeight: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div>
    <div class="thumbnail-wrapper">
      <div class="image-thumbnail">
        <img :src="avatar" />
      </div>
    </div>
    <h3 class="client-name" v-if="!isSidebarCollapsed">
      {{ fullName }}
    </h3>
    <p class="client-meta" v-if="!isSidebarCollapsed"
      >{{ gender ? `${gender} |` : '' }} {{ dob ? `${dob} |` : '' }}
      {{ userHeight ? userHeight : '' }}</p
    >
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.image-thumbnail {
  height: 9rem;
  margin-bottom: 0.7rem;
  margin-left: 10%;
  margin-right: 3.4rem;
  transition: width $duration-animation-base - 0.25 linear;
  width: 9rem;
  ::v-deep img {
    border-radius: $base-border-radius-md;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}

.client-name {
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
  height: 5rem;
  -webkit-line-clamp: 2;
  max-width: 100%;
  overflow: hidden;
  padding: 0 1.7rem;
  text-align: center;
  text-overflow: ellipsis;
}

.thumbnail-wrapper {
  padding: 0 4rem;
}

.client-meta {
  color: $color-medium-gray-alt;
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.1px;
  line-height: 2.2rem;
  margin-bottom: 1.5rem;
  padding: 0 2rem;
  text-transform: uppercase;
}
</style>
